<template>
    <div class="mx-sm-1 mt-9">
        <div class="page-header">
            <h1 class="page-title fw-bold">Les Utilisateurs</h1>
            <div>
                <ol class="breadcrumb">
                    <li class="breadcrumb-item"><router-link :to="{ name: 'dashboard' }"><a>Tableau de
                                bord</a></router-link></li>
                    <li class="breadcrumb-item active" aria-current="page"><router-link
                            :to="{ name: 'classeurs' }"><a>Les Utilisateurs</a></router-link></li>
                </ol>
            </div>
            <a class="modal-effect btn btn-secondary-light d-grid mb-3" data-bs-effect="effect-super-scaled"
                data-bs-toggle="modal" href="#modaldemo8">Ajouter un utilisateur</a>
        </div>
        <div class="row mb-3">
            <multi-select class="col-sm-3" @select="o => o.used = true" :options="columns.filter(o => !o.used)"
                :custom-label="v => v.description" placeholder="Filtrer par " label="name"
                track-by="name"></multi-select>
            <multi-select class="col-sm-3" :options="pagination" deselect-label="Sélectionné"
                :custom-label="v => v.description" placeholder="Eléments par page " label="value" track-by="value"
                :multiple="false" v-model="page"></multi-select>
            <div class="col-sm text-sm-right">
                <div class="dt-buttons btn-group">
                    <button aria-controls="kt_table_1" class="btn btn-outline-dark style_btn rounded-0" tabindex="1"
                        type="button" @click.prevent="onSearch"><span><i class="fe fe-search"></i>
                            Rechercher</span></button>
                    <!-- <button aria-controls="kt_table_1" class="btn btn-light style_btn rounded-0" tabindex="2"
                        type="button" @click.prevent="onCsv"><span><i class="fa fa-print"></i>
                            Exporter</span></button> -->
                </div>
            </div>
        </div>
        <div class="row">
            <div v-for="(item, index) in filters" :key="`filter${index}`" class="form-group col-sm">
                <div class="input-group">
                    <select v-if="item.options" v-model="item.value" class="form-control">
                        <option v-for="(obj, i) in item.options" :key="i" :value="obj.key">{{ obj.value }}</option>
                    </select>
                    <input v-else :type="item.type" class="form-control"
                        :placeholder="`Recherche de ${item.description}`" v-model="item.value">
                    <div class="input-group-append">
                        <button class="btn btn-danger" type="button" @click="item.used = false"><i
                                class="fe fe-trash"></i></button>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm col-md col-lg col-xl">
                <div class="card">
                    <div class="modal fade" id="modaldemo8">
                        <div class="modal-dialog modal-dialog-centered text-center" role="document">
                            <div class="modal-content modal-content-demo">
                                <div class="modal-header">
                                    <h6 class="modal-title">Création d'un utilisateur</h6><button aria-label="Close" id="closeButton"
                                        class="btn-close" data-bs-dismiss="modal"><span
                                            aria-hidden="true">&times;</span></button>
                                </div>
                                <div class="modal-body">
                                    <ValidationObserver v-slot="{ invalid }">
                                        <form @submit.prevent="submit" class="">
                                            <div class="form-row">
                                                <div class="form-group col-md-12 mb-0">
                                                    <ValidationProvider name="Contact" rules="" v-slot="{ errors }">
                                                        <label class="form-label">Contact </label>
                                                        <multi-select class="col-sm" :options="contacts"
                                                            v-model="payload.contact" :searchable="true"
                                                            :close-on-select="true" :show-labels="false"
                                                            :custom-label="v => v.nom + ' ' + v.prenom"
                                                            @select="o => affect(o)"
                                                            placeholder="Choisir le contact " label="nom"
                                                            track-by="idContact"></multi-select>

                                                        <small class="form-text text-danger">{{ errors[0] }}</small>
                                                    </ValidationProvider>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="form-group col-md-6 mb-0">
                                                    <ValidationProvider name="nom" rules="required" v-slot="{ errors }">
                                                        <label class="form-label mx-2">Nom <span
                                                                class="text-danger">*</span></label>
                                                        <input type="text" class="form-control" id="nom"
                                                            v-model="payload.nom" placeholder="saisir le nom">
                                                        <small class="form-text text-danger">{{ errors[0] }}</small>
                                                    </ValidationProvider>
                                                </div>
                                                <div class="form-group col-md-6 mb-0">
                                                    <ValidationProvider name="Prenoms" rules="required"
                                                        v-slot="{ errors }">
                                                        <label class="form-label mx-2">Prenoms <span
                                                                class="text-danger">*</span></label>
                                                        <input type="text" class="form-control" id="prenoms"
                                                            v-model="payload.prenoms" placeholder="saisir le prenom">
                                                        <small class="form-text text-danger">{{ errors[0] }}</small>
                                                    </ValidationProvider>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="form-group col-md-12 mb-0">
                                                    <ValidationProvider name="Email" rules="required|email"
                                                        v-slot="{ errors }">
                                                        <label class="form-label">Email <span
                                                                class="text-danger">*</span></label>
                                                        <!-- <input type="text" class="form-control" id="libelle" v-model="payload.libelle" placeholder="saisir le libelle" autocomplete="libelle"> -->
                                                        <input name="email" type="text" v-model="payload.email"
                                                            class="form-control" id="email"></input>
                                                        <small class="form-text text-danger">{{ errors[0] }}</small>
                                                    </ValidationProvider>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="form-group col-md-12 mb-0">
                                                    <ValidationProvider name="Role" rules="required"
                                                        v-slot="{ errors }">
                                                        <label class="form-label">Role <span
                                                                class="text-danger">*</span></label>
                                                        <multi-select class="col-sm" :options="roles"
                                                            v-model="payload.role" :searchable="true"
                                                            :close-on-select="true" :show-labels="false"
                                                            :custom-label="v => v.name" placeholder="Choisir role "
                                                            label="name" track-by="id"></multi-select>

                                                        <small class="form-text text-danger">{{ errors[0] }}</small>
                                                    </ValidationProvider>
                                                </div>
                                            </div>

                                            <div class="form-footer mt-2 d-flex justify-content-around">
                                                <div>
                                                    <button class="btn btn-success mt-4 mb-0" :disabled="invalid"
                                                        v-if="save"><span class="fe fe-check"></span>
                                                        Enregistrer</button>
                                                    <button class="btn btn-success mt-4 mb-0" :disabled="invalid"
                                                        v-else><span class="fe fe-check"></span> Modifier</button>
                                                </div>
                                                <div>
                                                    <a class="btn btn-danger mt-4 mb-0 text-end"
                                                        data-bs-dismiss="modal">Annuler</a>
                                                </div>
                                            </div>
                                        </form>
                                    </ValidationObserver>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade" id="contactModal">
                        <div class="modal-dialog modal-dialog text-center" role="document">
                            <div class="modal-content modal-content-demo">
                                <div class="modal-header">
                                    <h6 class="modal-title">Contact</h6><button aria-label="Close" class="btn-close"
                                        data-bs-dismiss="modal"><span aria-hidden="true">&times;</span></button>
                                </div>
                                <div class="modal-body">
                                    <fieldset>
                                        <legend>Informations</legend>
                                        <div class="row">
                                            <div class="col-md mb-3">
                                                <label for="disabledTextInput" class="form-label">Nom</label>
                                                <h4 class="form-control">{{ contact.nom }}</h4>
                                            </div>
                                            <div class="col-md mb-3">
                                                <label for="disabledTextInput" class="form-label">Prenom</label>
                                                <h4 class="form-control">{{ contact.prenom }}</h4>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md mb-3">
                                                <label for="disabledTextInput" class="form-label">Autre Prenoms</label>
                                                <h4 class="form-control">{{ contact.autrePrenom }}</h4>
                                            </div>
                                            <div class="col-md mb-3">
                                                <label for="disabledTextInput" class="form-label">Contact</label>
                                                <h4 class="form-control">{{ contact.contact }}</h4>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md mb-3">
                                                <label for="disabledTextInput" class="form-label">Courriel</label>
                                                <h4 class="form-control">{{ contact.courriel }}</h4>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md mb-3">
                                                <label for="disabledTextInput" class="form-label">Organisation</label>
                                                <h4 class="form-control">{{ contact.organisation?.organisation }}</h4>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md mb-3">
                                                <label for="disabledTextInput" class="form-label">Poste</label>
                                                <h4 class="form-control">{{ contact.poste?.libellePoste }}</h4>
                                            </div>
                                            <div class="col-md mb-3">
                                                <label for="disabledTextInput" class="form-label">Trigramme</label>
                                                <h4 class="form-control">{{ contact.trigramme }}</h4>
                                            </div>
                                        </div>
                                    </fieldset>
                                </div>
                                <div class="modal-footer">
                                    <button class="btn btn-light" data-bs-dismiss="modal">Fermer</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-header">
                        <h3 class="card-title">Liste</h3>
                        <div class="card-options">
                            <SearchInputAll></SearchInputAll>
                            <button class="btn text-primary btn-sm" @click="onSearch" data-bs-toggle="tooltip"
                                data-bs-original-title="Modifier"><span class="fe fe-search fs-18"></span></button>
                        </div>
                    </div>
                    <div class="card-body">
                        <table id="data-table"
                            class="table table-responsive table-hover table-bordered text-nowrap mb-0">
                            <thead class="border-top danger02">
                                <tr class="fw-bold">
                                    <th class="bg-transparent border-bottom-0 fw-bold" style="width: 5%;">N°</th>
                                    <th class="bg-transparent border-bottom-0 fw-bold">
                                        Nom d'utilisateur</th>
                                        <th class="bg-transparent border-bottom-0 fw-bold">
                                        Nom</th>
                                        <th class="bg-transparent border-bottom-0 fw-bold">
                                        Prenoms</th>
                                    <th class="bg-transparent border-bottom-0 fw-bold">
                                        Role</th>
                                    <th class="bg-transparent border-bottom-0 fw-bold">
                                        Contact</th>
                                    <th class="bg-transparent border-bottom-0 fw-bold">
                                        Permissions</th>
                                    <th class="bg-transparent border-bottom-0 fw-bold" style="width: 5%;">Actions</th>
                                </tr>
                            </thead>
                            <tbody v-if="filtersItems[0]" id="myTable1">
                                <tr v-for="(item, index) in filtersItems" :key="index" class="border-bottom">
                                    <td class="text-center">{{ parseInt(index + 1) }}</td>
                                    <td>{{ item?.username }}</td>
                                    <td>{{ item?.nom }}</td>
                                    <td>{{ item?.prenoms }}</td>
                                    <td>{{ item?.role ? item?.role?.name : 'Aucun' }}</td>
                                    <td>
                                        <div class="row" style="width: 150px;">
                                            <div class="mt-sm-1 d-block col-md">
                                                <span
                                                    :class="[item?.contact ? 'bg-success-transparent text-success' : 'bg-danger-transparent text-danger', 'badge rounded-pill p-2 px-3']">{{
                                                        item?.contact ? "Oui" : "Non" }}</span>
                                            </div>
                                            <button v-if="item.contact" class="btn text-primary btn-sm col-md"
                                                @click="showContact(item.contact)" data-bs-effect="effect-super-scaled"
                                                data-bs-toggle="modal" href="#contactModal"><span
                                                    class="fe fe-eye fs-18"></span></button>
                                        </div>

                                    </td>
                                    <td>
                                        <div v-if="item?.role?.id">
                                            <div v-if="item?.role.permissions.length === 0">Aucune permission</div>
                                            <div v-else>
                                                <ul class="list-inline mb-0">
                                                    <li class="" v-for="(perm, ind) in item?.role.permissions"
                                                        :key="ind">
                                                        <span class="badge bg-info-transparent text-info">{{ perm.libelle }}</span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div v-else>Aucune permission</div>
                                    </td>
                                    <td>
                                        <div class="g-2">
                                            <button class="btn text-primary btn-sm" @click="edit(item)"
                                                data-bs-effect="effect-super-scaled" data-bs-toggle="modal"
                                                href="#modaldemo8"><span class="fe fe-edit fs-18"></span></button>
                                            <button class="btn text-danger btn-sm" @click="drop(item)"
                                                data-bs-toggle="tooltip" data-bs-original-title="Supprimer"><span
                                                    class="fe fe-trash-2 fs-18"></span></button>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody v-else>
                                <tr class="primary02">
                                    <td colspan="9" class="text-center">Aucun utilisateur trouvé</td>
                                </tr>
                            </tbody>
                        </table>
                        <paginate :records="items.totalElements || 0" v-model="items.number" :per-page="items.size"
                        :options="{ theme: 'bootstrap4', edgeNavigation: true, texts: { count: `{from} à {to} de {count} éléments|{count} éléments|Un élément`, first: '<<<', last: '>>>' } }"
                        @paginate="onSearch" />
                    </div>
                </div>
            </div>
            <!-- COL END -->
            <!-- <div class="col-sm-12 col-md-12 col-lg-12 col-xl-4">
                <div class="card overflow-hidden">
                    <div class="card-header">
                        <h3 class="card-title">Création d'un utilisateur</h3>
                    </div>
                    <div class="card-body">
                        <ValidationObserver v-slot="{ invalid }">
                            <form @submit.prevent="submit" class="">
                                <div class="form-row">
                                    <div class="form-group col-md-6 mb-0">
                                        <ValidationProvider name="nom" rules="required" v-slot="{ errors }">
                                            <label class="form-label mx-2">Nom <span
                                                    class="text-danger">*</span></label>
                                            <input type="text" class="form-control" id="nom" v-model="payload.nom"
                                                placeholder="saisir le nom">
                                            <small class="form-text text-danger">{{ errors[0] }}</small>
                                        </ValidationProvider>
                                    </div>
                                    <div class="form-group col-md-6 mb-0">
                                        <ValidationProvider name="Prenoms" rules="required" v-slot="{ errors }">
                                            <label class="form-label mx-2">Prenoms <span
                                                    class="text-danger">*</span></label>
                                            <input type="text" class="form-control" id="prenoms"
                                                v-model="payload.prenoms" placeholder="saisir le prenom">
                                            <small class="form-text text-danger">{{ errors[0] }}</small>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="form-group col-md-12 mb-0">
                                        <ValidationProvider name="Email" rules="required|email" v-slot="{ errors }">
                                            <label class="form-label">Email <span class="text-danger">*</span></label>
                                            <input name="email" type="text" v-model="payload.email" class="form-control"
                                                id="email"></input>
                                            <small class="form-text text-danger">{{ errors[0] }}</small>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="form-group col-md-12 mb-0">
                                        <ValidationProvider name="Role" rules="required" v-slot="{ errors }">
                                            <label class="form-label">Role <span class="text-danger">*</span></label>
                                            <multi-select class="col-sm" :options="roles" v-model="payload.role"
                                                :searchable="true" :close-on-select="true" :show-labels="false"
                                                :custom-label="v => v.name" placeholder="Choisir role " label="name"
                                                track-by="id"></multi-select>

                                            <small class="form-text text-danger">{{ errors[0] }}</small>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="form-group col-md-12 mb-0">
                                        <ValidationProvider name="Contact" rules="" v-slot="{ errors }">
                                            <label class="form-label">Contact </label>
                                            <multi-select class="col-sm" :options="contacts" v-model="payload.contact"
                                                :searchable="true" :close-on-select="true" :show-labels="false"
                                                :custom-label="v => v.nom + ' ' + v.prenom"
                                                placeholder="Choisir le contact " label="nom"
                                                track-by="id"></multi-select>

                                            <small class="form-text text-danger">{{ errors[0] }}</small>
                                        </ValidationProvider>
                                    </div>
                                </div>

                                <div class="form-footer mt-2 d-flex justify-content-around">
                                    <div>
                                        <button class="btn btn-success mt-4 mb-0" :disabled="invalid" v-if="save"><span
                                                class="fe fe-check"></span> Enregistrer</button>
                                        <button class="btn btn-success mt-4 mb-0" :disabled="invalid" v-else><span
                                                class="fe fe-check"></span> Modifier</button>
                                    </div>
                                    <div>
                                        <a class="btn btn-danger mt-4 mb-0 text-end" data-bs-dismiss="modal">Annuler</a>
                                    </div>
                                </div>
                            </form>
                        </ValidationObserver>
                    </div>
                </div>
            </div> -->

        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { reduce } from "lodash";
export default {
    name: "Utilisateur",
    data() {
        return {
            loading: false,
            payload: { id: "", username: "" }, save: true,
            contact: {},
            columns: [
                { name: 'id', description: 'User ID', type: 'text', used: false },
                { name: 'username', description: 'Nom d\'utilisateur', type: 'text', used: false },
                { name: 'email', description: 'Adresse mail', type: 'text', used: false },
                { name: 'nom', description: 'Nom', type: 'text', used: false },
                { name: 'prenoms', description: 'Prenoms', type: 'text', used: false },
            ],
            page: { name: 'size', description: '10 par page', value: 10, type: 'number', used: false },
            pagination: [
                { name: 'size', description: '10 par page', value: 10, type: 'number', used: false },
                { name: 'size', description: '20 par page', value: 20, type: 'number', used: false },
                { name: 'size', description: '30 par page', value: 30, type: 'number', used: false },
                { name: 'size', description: '40 par page', value: 40, type: 'number', used: false },
                { name: 'size', description: '50 par page', value: 50, type: 'number', used: false },
                { name: 'size', description: '60 par page', value: 60, type: 'number', used: false },
                { name: 'size', description: '70 par page', value: 70, type: 'number', used: false },
            ],
            exportations: [
                { name: 'ACCEPTED', description: 'Acceptée' },
                { name: 'REFUSED', description: 'Refusée' },
                { name: 'PENDING', description: 'En Cours' },
                { name: 'DIFFERED', description: 'Différée' },
                { name: 'PROCESSED', description: 'En Traitement' },
            ],
            reinit: false,
        }
    },
    watch: {
        page: {
            deep: true,
            immediate: true,
            handler(value) {
                this.reinit = true;
                this.onSearch();
            }
        }
    },
    computed: {
        ...mapGetters({ items: 'users/list' }),
        ...mapGetters({ roles: 'role/list' }),
        ...mapGetters({ contacts: 'contact/list' }),
        filtersItems() {
            return this.items?.content || [];
        },
        filters() {
            return this.columns.filter(o => o.used);
        },
        option() {
            return reduce(this.filters, (acc, item) => (acc[item.name] = item.value, acc), {})
        },
    },
    methods: {
        ...mapActions('users', ['all', 'add']),
        onSearch(offset) {
            this.$loading(true);
            if (offset > 0) this.option.page = offset - 1;
            //Réinitialiser la page quand le nombre de page change
            if (this.reinit){
                this.option.page = 0;
                this.reinit = false;
            }
            if(this.page) this.option.size = this.page.value;
            this.$router.push({ query: this.option }).catch(() => { });
            this.$store.dispatch('users/all', this.option).finally(() => this.$loading(false));
        },
        affect(value) {
            this.payload.nom = value.nom;
            this.payload.prenoms = value.prenom;
            this.payload.email = value.courriel;
        },
        submit() {
            this.$loading(true);
            this.loading = true;
            this.payload.username = this.payload.email;
            if (this.save) {
                console.log(this.payload);
                this.$http.post('/users/actions', this.payload)
                    .then(({ data }) => {
                        if (data.status) {
                            swal('Information!', data.message, 'success');
                        } else {
                            swal('Information!', data.message, 'error');
                        }
                        this.onSearch();
                        this.$loading(false);
                        document.getElementById("closeButton").click();
                    });
            } else {
                console.log("Editer", this.payload);
                this.$http.put('/users/actions/' + this.payload.id, this.payload)
                    .then(({ data }) => {
                        if (data.id) {
                            swal('Information!', "Modification fait avec succes", 'success');
                        } else {
                            swal('Information!', "Erreur lors de la modification", 'error');
                        }
                        this.onSearch();
                        this.$loading(false);
                        document.getElementById("closeButton").click();
                    });
            }
        },
        edit(value) {
            this.$loading(true);
            this.save = false;
            this.payload = { ...value };
            this.$loading(false);
        },
        showContact(value) {
            this.contact = { ...value };
        },
        drop(item) {
            const self = this;
            swal({
                title: "Vous voulez continuer?",
                text: "La selection sera supprimee!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#FF0000",
                cancelButtonColor: "#d33",
                confirmButtonText: "Oui, supprimer!",
                cancelButtonText: "Annuler!"
            }, function(result) {
                if (result === true) {
                    self.$loading(true);
                    self.$http.delete('/users/actions/' + item.id)
                        .then(({ data, status }) => {
                            if (status === 200 || status === 201) {
                                swal('Information!', "Suppression effectuee", 'success');
                            } else {
                                swal('Information!', "Suppression non efective", 'error');
                            }
                            self.$loading(false);
                            self.onSearch();
                        }).catch((error) => {
                            self.$loading(false);
                            swal('Erreur!', 'Une erreur est survenue lors de la suppression de l\'utilisateur.', 'error');
                        });
                }
            });

        },
    },
    created() {
        this.onSearch();
        this.$store.dispatch('role/allData');
        this.$store.dispatch('contact/allData');
    }
}
</script>

<style></style>